import { ExpandableList } from '@optimus-web/core';
import { MonthListItem } from '../MonthListItem';

interface ServiceListProps {
    months: string[];
    billId: string;
    accountId: string;
    scope: string;
}

export const MonthList: React.FC<ServiceListProps> = ({ months, billId, accountId, scope }) => (
    <ExpandableList multiSelect>
        {months.map((month) => (
            <MonthListItem
                key={`${billId}-${month}`}
                month={month}
                billId={billId}
                accountId={accountId}
                scope={scope}
                value={`${billId}-${month}`}
            />
        ))}
    </ExpandableList>
);
